module.exports = __webpack_public_path__ + "static/img/jiarubanner.57895e7f.png";